import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { FullComponent } from '../layouts/full/full.component';
import { AppSidebarComponent } from '../layouts/full/sidebar/sidebar.component';
import { AppHeaderComponent } from '../layouts/full/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { ViewUserProfileComponent } from './view-user-profile/view-user-profile.component';
import { MatExpansionModule } from '@angular/material';
import { HomeService } from './home.service';
import { EditUserProfileComponent } from './edit-user-profile/edit-user-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ViewProfileModalComponent } from './view-profile-modal/view-profile-modal.component';
import { FillFormComponent } from './fill-form/fill-form.component';

import { MultipeFormListComponent } from './multipe-form-list/multipe-form-list.component';
import { EditUserMultipleFormComponent } from './edit-user-multiple-form/edit-user-multiple-form.component';
import { ListFormUsersComponent } from './list-form-users/list-form-users.component';
import { UserInFormsComponent } from './usersinform/user-in-forms.component';
import { UserResponseFormViewComponent } from './user-response-form-view/user-response-form-view.component';
import { TabularViewComponent } from './tabular-view/tabular-view.component';
import { FormAuditsComponent } from './form-audits/form-audits.component';
import { FileService } from '../shared/fileService';
import { FillFormModalComponent } from './fill-form-modal/fill-form-modal.component';
import { HeaderSortComponent } from './header-sort/header-sort.component';
import { CalendarReportComponent } from './calendar-report/calendar-report.component';
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';
import { DynamicDashboardComponent } from './dynamic-dashboard/dynamic-dashboard.component';


@NgModule({
  declarations: [MainComponent,FullComponent,AppSidebarComponent,AppHeaderComponent, ViewUserProfileComponent,
     EditUserProfileComponent,ChangePasswordComponent, ViewProfileModalComponent, FillFormComponent, 
     UserInFormsComponent,MultipeFormListComponent, EditUserMultipleFormComponent, ListFormUsersComponent, 
     UserResponseFormViewComponent, TabularViewComponent, FormAuditsComponent, FillFormModalComponent, 
     HeaderSortComponent, CalendarReportComponent, NotificationPanelComponent, DynamicDashboardComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule,
    MatExpansionModule
    // DemoMaterialModule
  ],
  entryComponents: [
    ViewProfileModalComponent,
    FillFormModalComponent
  ],
  providers:[HomeService,FileService]
})
export class MainModule { }
